import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useState } from "react";

function numberToChinese(num){
 const map = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
 const num_d = num.toString().split('').map(d => map[+d]).join('');
         console.log(num_d);
    return num_d;
}

export default function CountUp({ from = 0, to = 100, duration = 2 }) {
  const count = useMotionValue(from);
  const rounded = useTransform(count, (latest) => Math.floor(latest));
  const [display, setDisplay] = useState(from);

  useEffect(() => {
    const controls = animate(count, to, {
      duration,
      onUpdate: (v) => setDisplay(Math.floor(v)),
    });
    return () => controls.stop(); // cleanup
  }, [to, duration, count]);

  return (
    <motion.span className="counter" id="counter" style={{ fontSize: "2rem", fontWeight: "bold" }}>
      {display.toLocaleString()}
    </motion.span>
  );
}